import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/fonts/Marianne-Thin.woff2%22,%22weight%22:%22100%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Marianne-Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Marianne-Regular.woff2%22,%22weight%22:%22normal%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Marianne-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Marianne-Bold.woff2%22,%22weight%22:%22bold%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/Marianne-ExtraBold.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22}],%22variable%22:%22--font-marianne%22}],%22variableName%22:%22marianne%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'marianne', 'marianne Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
